






import { defineComponent } from "@vue/composition-api";

export default defineComponent({
  name: "PageSubTitle",
  props: {
    title: { type: String },
  },
});
